import { useEffect, useState } from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { ShoppingBag, TrendingUp, Package, FileText } from "lucide-react";
import api from "@/lib/api";

const Card = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white border border-xd-border rounded-xl p-5">
    <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${color}`}><Icon className="w-5 h-5" /></div>
    <div className="text-xs text-xd-muted font-mono-tech uppercase tracking-widest">{label}</div>
    <div className="text-2xl font-admin font-bold mt-1">{value}</div>
  </div>
);

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)); }, []);

  return (
    <AdminLayout>
      <div className="mb-6">
        <div className="font-mono-tech text-[10px] uppercase tracking-widest text-xd-muted">Overview</div>
        <h1 className="font-admin text-2xl font-bold">Dashboard</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card icon={ShoppingBag} label="Ordini totali" value={data?.orders_total ?? "—"} color="bg-xd-cyan/10 text-xd-cyanHover" />
        <Card icon={TrendingUp} label="Fatturato" value={`€ ${data?.revenue_total?.toFixed(2) ?? "—"}`} color="bg-xd-orange/10 text-xd-orangeHover" />
        <Card icon={Package} label="Prodotti attivi" value={data?.products_active ?? "—"} color="bg-xd-success/10 text-xd-success" />
        <Card icon={FileText} label="Articoli blog" value={data?.blog_total ?? "—"} color="bg-slate-100 text-slate-700" />
      </div>

      <div className="mt-8 bg-white border border-xd-border rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="font-admin font-bold text-lg">Vendite ultimi 7 giorni</div>
            <div className="text-xs text-xd-muted">Fatturato per giornata (€)</div>
          </div>
        </div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data?.sales_last_7_days || []}>
              <CartesianGrid stroke="#E4E9F1" strokeDasharray="3 3" />
              <XAxis dataKey="date" fontSize={11} tickFormatter={(d) => d.slice(5)} />
              <YAxis fontSize={11} />
              <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E4E9F1" }} />
              <Bar dataKey="revenue" fill="#17C7D6" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </AdminLayout>
  );
}
